export const LayoutStyleClean = ( { activeStyle } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 60 }
		height={ 56 }
		fill="none"
	>
		<rect
			width={ 58.5 }
			height={ 54.5 }
			x={ 0.75 }
			y={ 0.75 }
			stroke={ activeStyle ? '#458dd7' : '#8796A1' }
			strokeWidth={ 1.5 }
			rx={ 1.25 }
		/>
		<rect
			width={ 39 }
			height={ 38 }
			x={ 10.5 }
			y={ 9 }
			fill="#fff"
			stroke="#8796A1"
			rx={ 1.5 }
		/>
		<rect
			width={ 4 }
			height={ 4 }
			x={ 15 }
			y={ 14 }
			fill="#8796A1"
			rx={ 2 }
		/>
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 15 }
			fill="#8796A1"
			rx={ 1 }
		/>
		<rect
			width={ 4 }
			height={ 4 }
			x={ 15 }
			y={ 22 }
			fill="#8796A1"
			rx={ 2 }
		/>
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 23 }
			fill="#8796A1"
			rx={ 1 }
		/>
		<rect
			width={ 4 }
			height={ 4 }
			x={ 15 }
			y={ 30 }
			fill="#8796A1"
			rx={ 2 }
		/>
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 31 }
			fill="#8796A1"
			rx={ 1 }
		/>
		<rect
			width={ 4 }
			height={ 4 }
			x={ 15 }
			y={ 38 }
			fill="#8796A1"
			rx={ 2 }
		/>
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 39 }
			fill="#8796A1"
			rx={ 1 }
		/>
	</svg>
);

export const LayoutStyleDivided = ( { activeStyle } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 60 }
		height={ 56 }
		fill="none"
	>
		<rect
			width={ 58.5 }
			height={ 54.5 }
			x={ 0.75 }
			y={ 0.75 }
			stroke={ activeStyle ? '#458dd7' : '#8796A1' }
			strokeWidth={ 1.5 }
			rx={ 1.25 }
		/>
		<rect
			width={ 39 }
			height={ 38 }
			x={ 10.5 }
			y={ 9 }
			fill="#fff"
			rx={ 1.5 }
		/>
		<rect
			width={ 39 }
			height={ 38 }
			x={ 10.5 }
			y={ 9 }
			stroke="#8796A1"
			rx={ 1.5 }
		/>
		<rect
			width={ 4 }
			height={ 4 }
			x={ 15 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 2 }
		/>
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 13.5 }
			fill="#8796A1"
			rx={ 1 }
		/>
		<rect
			width={ 40 }
			height={ 1 }
			x={ 10 }
			y={ 20.5 }
			fill="#8796A1"
			rx={ 0.5 }
		/>
		<rect
			width={ 4 }
			height={ 4 }
			x={ 15 }
			y={ 25.5 }
			fill="#8796A1"
			rx={ 2 }
		/>
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 26.5 }
			fill="#8796A1"
			rx={ 1 }
		/>
		<rect
			width={ 40 }
			height={ 1 }
			x={ 10 }
			y={ 33.5 }
			fill="#8796A1"
			rx={ 0.5 }
		/>
		<rect
			width={ 4 }
			height={ 4 }
			x={ 15 }
			y={ 38.5 }
			fill="#8796A1"
			rx={ 2 }
		/>
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 39.5 }
			fill="#8796A1"
			rx={ 1 }
		/>
	</svg>
);

export const LayoutStyleStriped = ( { activeStyle } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 60 }
		height={ 56 }
		fill="none"
	>
		<rect
			width={ 58.5 }
			height={ 54.5 }
			x={ 0.75 }
			y={ 0.75 }
			stroke={ activeStyle ? '#458dd7' : '#8796A1' }
			strokeWidth={ 1.5 }
			rx={ 1.25 }
		/>
		<rect
			width={ 39 }
			height={ 39 }
			x={ 10.5 }
			y={ 8.5 }
			fill="#fff"
			stroke="#8796A1"
			rx={ 1.5 }
		/>
		<rect
			width={ 4 }
			height={ 4 }
			x={ 15 }
			y={ 11 }
			fill="#8796A1"
			rx={ 2 }
		/>
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 12 }
			fill="#8796A1"
			rx={ 1 }
		/>
		<path fill="#8796A1" d="M10 18h40v10H10z" />
		<rect
			width={ 4 }
			height={ 4 }
			x={ 15 }
			y={ 18 }
			fill="#8796A1"
			rx={ 2 }
		/>
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 19 }
			fill="#8796A1"
			rx={ 1 }
		/>
		<rect width={ 4 } height={ 4 } x={ 15 } y={ 21 } fill="#fff" rx={ 2 } />
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 22 }
			fill="#fff"
			rx={ 1 }
		/>
		<path
			fill="#8796A1"
			d="M10 38h40v6c0 1.886 0 2.828-.586 3.414C48.828 48 47.886 48 46 48H14c-1.886 0-2.828 0-3.414-.586C10 46.828 10 45.886 10 44v-6Z"
		/>
		<rect width={ 4 } height={ 4 } x={ 15 } y={ 41 } fill="#fff" rx={ 2 } />
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 42 }
			fill="#fff"
			rx={ 1 }
		/>
		<rect
			width={ 4 }
			height={ 4 }
			x={ 15 }
			y={ 31 }
			fill="#8796A1"
			rx={ 2 }
		/>
		<rect
			width={ 24 }
			height={ 2 }
			x={ 21 }
			y={ 32 }
			fill="#8796A1"
			rx={ 1 }
		/>
	</svg>
);

export const AdditionalGridOneLayout = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 90 }
		height={ 100 }
		fill="none"
	>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			fill="#fff"
			rx={ 2.438 }
		/>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			stroke="#8796A1"
			strokeWidth={ 1.125 }
			rx={ 2.438 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			fill="#fff"
			rx={ 1.125 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			stroke="#8796A1"
			strokeWidth={ 0.75 }
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 12 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 12 }
			y={ 23 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.75 }
			height={ 2.25 }
			x={ 12 }
			y={ 26.75 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 12 }
			y={ 41.75 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 12 }
			y={ 52.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 12 }
			y={ 56 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 12 }
			y={ 71 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 12 }
			y={ 81.5 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 11.25 }
			height={ 2.25 }
			x={ 12 }
			y={ 85.25 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 35.25 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 9.75 }
			height={ 2.25 }
			x={ 35.25 }
			y={ 23 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 35.25 }
			y={ 26.75 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 35.25 }
			y={ 41.75 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 35.25 }
			y={ 52.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 18.75 }
			height={ 2.25 }
			x={ 35.25 }
			y={ 56 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 35.25 }
			y={ 71 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 35.25 }
			y={ 81.5 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 11.25 }
			height={ 2.25 }
			x={ 35.25 }
			y={ 85.25 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 59.25 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 23 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 10.5 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 26.75 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 59.25 }
			y={ 41.75 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 18.75 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 52.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 56 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 59.25 }
			y={ 71 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 6.75 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 81.5 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 85.25 }
			fill="#546069"
			rx={ 1.125 }
		/>
	</svg>
);

export const AdditionalGridTwoLayout = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 90 }
		height={ 100 }
		fill="none"
	>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			fill="#fff"
			rx={ 2.438 }
		/>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			stroke="#8796A1"
			strokeWidth={ 1.125 }
			rx={ 2.438 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			fill="#fff"
			rx={ 1.125 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			stroke="#8796A1"
			strokeWidth={ 0.75 }
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 17.25 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 12 }
			y={ 23 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.75 }
			height={ 2.25 }
			x={ 16.125 }
			y={ 26.75 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 17.25 }
			y={ 41.75 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 12 }
			y={ 52.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 15 }
			y={ 56 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 17.25 }
			y={ 71 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 13.125 }
			y={ 81.5 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 11.25 }
			height={ 2.25 }
			x={ 15.375 }
			y={ 85.25 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 40.875 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 9.75 }
			height={ 2.25 }
			x={ 39.75 }
			y={ 23 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 36.75 }
			y={ 26.75 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 40.875 }
			y={ 41.75 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 37.875 }
			y={ 52.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 18.75 }
			height={ 2.25 }
			x={ 35.25 }
			y={ 56 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 40.875 }
			y={ 71 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 36.75 }
			y={ 81.5 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 11.25 }
			height={ 2.25 }
			x={ 39 }
			y={ 85.25 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 64.875 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 62.625 }
			y={ 23 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 10.5 }
			height={ 2.25 }
			x={ 63.375 }
			y={ 26.75 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 64.875 }
			y={ 41.75 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 18.75 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 52.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15 }
			height={ 2.25 }
			x={ 61.125 }
			y={ 56 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 64.875 }
			y={ 71 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 6.75 }
			height={ 2.25 }
			x={ 65.25 }
			y={ 81.5 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 61.5 }
			y={ 85.25 }
			fill="#546069"
			rx={ 1.125 }
		/>
	</svg>
);

export const ListTwoColJustified = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 90 }
		height={ 100 }
		fill="none"
	>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			fill="#fff"
			rx={ 2.438 }
		/>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			stroke="#8796A1"
			strokeWidth={ 1.125 }
			rx={ 2.438 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			fill="#fff"
			rx={ 1.125 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			stroke="#8796A1"
			strokeWidth={ 0.75 }
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 16.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 17.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.75 }
			height={ 2.25 }
			x={ 32.25 }
			y={ 17.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 26.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 10.5 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 27.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.375 }
			height={ 2.25 }
			x={ 29.25 }
			y={ 27.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 37.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 38.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.375 }
			height={ 2.25 }
			x={ 30.75 }
			y={ 38.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 47.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 48.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 6 }
			height={ 2.25 }
			x={ 32.25 }
			y={ 48.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 58.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 11.25 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 59.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 30 }
			y={ 59.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 68.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 7.5 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 69.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.375 }
			height={ 2.25 }
			x={ 26.25 }
			y={ 69.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 79.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 10.5 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 80.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 8.25 }
			height={ 2.25 }
			x={ 29.25 }
			y={ 80.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 48 }
			y={ 16.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 54 }
			y={ 17.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 70.5 }
			y={ 17.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 48 }
			y={ 26.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 54 }
			y={ 27.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 65.25 }
			y={ 27.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 49.875 }
			y={ 37.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 55.875 }
			y={ 38.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.375 }
			height={ 2.25 }
			x={ 70.125 }
			y={ 38.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 51.75 }
			y={ 47.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 10.5 }
			height={ 2.25 }
			x={ 57.75 }
			y={ 48.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 70.5 }
			y={ 48.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 48 }
			y={ 58.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 54 }
			y={ 59.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 70.5 }
			y={ 59.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 54.375 }
			y={ 68.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 7.5 }
			height={ 2.25 }
			x={ 60.375 }
			y={ 69.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.375 }
			height={ 2.25 }
			x={ 70.125 }
			y={ 69.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 52.5 }
			y={ 79.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 10.5 }
			height={ 2.25 }
			x={ 58.5 }
			y={ 80.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 8.25 }
			height={ 2.25 }
			x={ 71.25 }
			y={ 80.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
	</svg>
);

export const ListTwoColumn = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 90 }
		height={ 100 }
		fill="none"
	>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			fill="#fff"
			rx={ 2.438 }
		/>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			stroke="#8796A1"
			strokeWidth={ 1.125 }
			rx={ 2.438 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			fill="#fff"
			rx={ 1.125 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			stroke="#8796A1"
			strokeWidth={ 0.75 }
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 16.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 17.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.75 }
			height={ 2.25 }
			x={ 32.25 }
			y={ 17.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 26.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 10.5 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 27.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.375 }
			height={ 2.25 }
			x={ 29.25 }
			y={ 27.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 37.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 38.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.375 }
			height={ 2.25 }
			x={ 30.75 }
			y={ 38.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 47.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 48.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 6 }
			height={ 2.25 }
			x={ 32.25 }
			y={ 48.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 58.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 11.25 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 59.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 30 }
			y={ 59.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 68.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 7.5 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 69.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.375 }
			height={ 2.25 }
			x={ 26.25 }
			y={ 69.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 10.5 }
			y={ 79.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 10.5 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 80.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 8.25 }
			height={ 2.25 }
			x={ 29.25 }
			y={ 80.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 48 }
			y={ 16.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 54 }
			y={ 17.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 70.5 }
			y={ 17.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 48 }
			y={ 26.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 54 }
			y={ 27.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 65.25 }
			y={ 27.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 48 }
			y={ 37.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 54 }
			y={ 38.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.375 }
			height={ 2.25 }
			x={ 68.25 }
			y={ 38.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 48 }
			y={ 47.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 54 }
			y={ 48.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 65.25 }
			y={ 48.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 48 }
			y={ 58.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 54 }
			y={ 59.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 70.5 }
			y={ 59.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 48 }
			y={ 68.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 7.5 }
			height={ 2.25 }
			x={ 54 }
			y={ 69.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.375 }
			height={ 2.25 }
			x={ 63.75 }
			y={ 69.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 48 }
			y={ 79.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 10.5 }
			height={ 2.25 }
			x={ 54 }
			y={ 80.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 8.25 }
			height={ 2.25 }
			x={ 66.75 }
			y={ 80.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
	</svg>
);

export const ListTwoColumnOne = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 90 }
		height={ 100 }
		fill="none"
	>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			fill="#fff"
			rx={ 2.438 }
		/>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			stroke="#8796A1"
			strokeWidth={ 1.125 }
			rx={ 2.438 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			fill="#fff"
			rx={ 1.125 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			stroke="#8796A1"
			strokeWidth={ 0.75 }
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 12 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 13.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.75 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 17 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 12 }
			y={ 26 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 26.75 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 18.75 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 30.5 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 12 }
			y={ 39.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 40.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 11.25 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 44 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 12 }
			y={ 53 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 53.75 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 57.5 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 12 }
			y={ 66.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 67.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 71 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 12 }
			y={ 80 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 80.75 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.75 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 84.5 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 48.75 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 16.5 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 13.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12.75 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 17 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 48.75 }
			y={ 26 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 18.75 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 26.75 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 30.5 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 48.75 }
			y={ 39.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 6.75 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 40.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 44 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 48.75 }
			y={ 53 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 53.75 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 6.75 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 57.5 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 48.75 }
			y={ 66.5 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 11.25 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 67.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 71 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 48.75 }
			y={ 80 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 80.75 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.75 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 84.5 }
			fill="#546069"
			rx={ 1.125 }
		/>
	</svg>
);

export const ListCenter = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 90 }
		height={ 100 }
		fill="none"
	>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			fill="#fff"
			rx={ 2.438 }
		/>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			stroke="#8796A1"
			strokeWidth={ 1.125 }
			rx={ 2.438 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			fill="#fff"
			rx={ 1.125 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			stroke="#8796A1"
			strokeWidth={ 0.75 }
			rx={ 1.125 }
		/>
		<path
			fill="#8796A1"
			d="M15 85.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
		/>
		<rect
			width={ 15 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 84.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<path
			fill="#8796A1"
			d="M40.125 85.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 41.625 }
			y={ 84.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<path
			fill="#8796A1"
			d="M64.5 85.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 66 }
			y={ 84.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 27.75 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 13.625 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 57 }
			y={ 13.625 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 29.25 }
			y={ 19.625 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 36 }
			y={ 20.75 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 51.75 }
			y={ 20.75 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 25.5 }
			y={ 26.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 32.25 }
			y={ 27.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12.75 }
			height={ 2.25 }
			x={ 51.75 }
			y={ 27.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 33.875 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 35 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 21.75 }
			height={ 2.25 }
			x={ 47.25 }
			y={ 35 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 28.125 }
			y={ 41 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 16.5 }
			height={ 2.25 }
			x={ 34.875 }
			y={ 42.125 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 52.875 }
			y={ 42.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 24.75 }
			y={ 48.125 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 20.25 }
			height={ 2.25 }
			x={ 31.5 }
			y={ 49.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 53.25 }
			y={ 49.25 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 28.5 }
			y={ 55.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 35.25 }
			y={ 56.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 52.5 }
			y={ 56.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 24 }
			y={ 62.375 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 30.75 }
			y={ 63.5 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 50.25 }
			y={ 63.5 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 69.5 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 24.75 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 70.625 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15 }
			height={ 2.25 }
			x={ 54 }
			y={ 70.625 }
			fill="#546069"
			rx={ 1.125 }
		/>
	</svg>
);

export const ListJustified = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 90 }
		height={ 100 }
		fill="none"
	>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			fill="#fff"
			rx={ 2.438 }
		/>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			stroke="#8796A1"
			strokeWidth={ 1.125 }
			rx={ 2.438 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			fill="#fff"
			rx={ 1.125 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			stroke="#8796A1"
			strokeWidth={ 0.75 }
			rx={ 1.125 }
		/>
		<path
			fill="#8796A1"
			d="M15 85.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
		/>
		<rect
			width={ 15 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 84.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<path
			fill="#8796A1"
			d="M40.125 85.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 41.625 }
			y={ 84.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<path
			fill="#8796A1"
			d="M64.5 85.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 66 }
			y={ 84.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 15 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 27.75 }
			height={ 2.25 }
			x={ 21 }
			y={ 13.625 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 63 }
			y={ 13.625 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 15 }
			y={ 19.625 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 21 }
			y={ 20.75 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 59.25 }
			y={ 20.75 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 15 }
			y={ 26.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 21 }
			y={ 27.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 57 }
			y={ 27.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 15 }
			y={ 33.875 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 21 }
			y={ 35 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 26.25 }
			height={ 2.25 }
			x={ 48.75 }
			y={ 35 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 15 }
			y={ 41 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 16.5 }
			height={ 2.25 }
			x={ 21 }
			y={ 42.125 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 10.5 }
			height={ 2.25 }
			x={ 64.5 }
			y={ 42.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 15 }
			y={ 48.125 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 19.5 }
			height={ 2.25 }
			x={ 21 }
			y={ 49.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15 }
			height={ 2.25 }
			x={ 60 }
			y={ 49.25 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 15 }
			y={ 55.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 21 }
			y={ 56.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 24.75 }
			height={ 2.25 }
			x={ 50.25 }
			y={ 56.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 15 }
			y={ 62.375 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 21 }
			y={ 63.5 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 18.75 }
			height={ 2.25 }
			x={ 56.25 }
			y={ 63.5 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 15 }
			y={ 69.5 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 24 }
			height={ 2.25 }
			x={ 21 }
			y={ 70.625 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15 }
			height={ 2.25 }
			x={ 60 }
			y={ 70.625 }
			fill="#546069"
			rx={ 1.125 }
		/>
	</svg>
);

export const ListLeft = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 90 }
		height={ 100 }
		fill="none"
	>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			fill="#fff"
			rx={ 2.438 }
		/>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			stroke="#8796A1"
			strokeWidth={ 1.125 }
			rx={ 2.438 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			fill="#fff"
			rx={ 1.125 }
		/>
		<rect
			width={ 77.25 }
			height={ 86.25 }
			x={ 6.375 }
			y={ 6.875 }
			stroke="#8796A1"
			strokeWidth={ 0.75 }
			rx={ 1.125 }
		/>
		<path
			fill="#8796A1"
			d="M15 85.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
		/>
		<rect
			width={ 15 }
			height={ 2.25 }
			x={ 16.5 }
			y={ 84.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<path
			fill="#8796A1"
			d="M40.125 85.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 41.625 }
			y={ 84.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<path
			fill="#8796A1"
			d="M64.5 85.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
		/>
		<rect
			width={ 13.5 }
			height={ 2.25 }
			x={ 66 }
			y={ 84.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 12.5 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 27.75 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 13.625 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 57 }
			y={ 13.625 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 19.625 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 14.25 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 20.75 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 43.5 }
			y={ 20.75 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 26.75 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 27.875 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12.75 }
			height={ 2.25 }
			x={ 47.25 }
			y={ 27.875 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 33.875 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 35 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 21.75 }
			height={ 2.25 }
			x={ 47.25 }
			y={ 35 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 41 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 16.5 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 42.125 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 45.75 }
			y={ 42.125 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 48.125 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 20.25 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 49.25 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 49.5 }
			y={ 49.25 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 55.25 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 56.375 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9 }
			height={ 2.25 }
			x={ 45 }
			y={ 56.375 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 62.375 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 63.5 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 47.25 }
			y={ 63.5 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 21 }
			y={ 69.5 }
			fill="#8796A1"
			rx={ 2.25 }
		/>
		<rect
			width={ 24.75 }
			height={ 2.25 }
			x={ 27.75 }
			y={ 70.625 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 15 }
			height={ 2.25 }
			x={ 54 }
			y={ 70.625 }
			fill="#546069"
			rx={ 1.125 }
		/>
	</svg>
);

export const CarouselFlat = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 90 }
		height={ 100 }
		fill="none"
	>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			fill="#fff"
			rx={ 2.438 }
		/>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			stroke="#8796A1"
			strokeWidth={ 1.125 }
			rx={ 2.438 }
		/>
		<rect
			width={ 77.25 }
			height={ 24.75 }
			x={ 6.375 }
			y={ 37.625 }
			fill="#fff"
			rx={ 1.125 }
		/>
		<rect
			width={ 77.25 }
			height={ 24.75 }
			x={ 6.375 }
			y={ 37.625 }
			stroke="#8796A1"
			strokeWidth={ 0.75 }
			rx={ 1.125 }
		/>
		<rect
			width={ 31.5 }
			height={ 7.5 }
			x={ 12 }
			y={ 46.25 }
			fill="#8796A1"
			rx={ 0.75 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 15 }
			y={ 47.75 }
			fill="#F6F7F7"
			rx={ 2.25 }
		/>
		<rect
			width={ 18 }
			height={ 1.5 }
			x={ 22.5 }
			y={ 47.75 }
			fill="#F6F7F7"
			rx={ 0.75 }
		/>
		<rect
			width={ 9.75 }
			height={ 1.5 }
			x={ 22.5 }
			y={ 50.75 }
			fill="#F6F7F7"
			rx={ 0.75 }
		/>
		<rect
			width={ 31.5 }
			height={ 7.5 }
			x={ 46.5 }
			y={ 46.25 }
			fill="#8796A1"
			rx={ 0.75 }
		/>
		<rect
			width={ 4.5 }
			height={ 4.5 }
			x={ 49.5 }
			y={ 47.75 }
			fill="#F6F7F7"
			rx={ 2.25 }
		/>
		<rect
			width={ 13.5 }
			height={ 1.5 }
			x={ 57 }
			y={ 47.75 }
			fill="#F6F7F7"
			rx={ 0.75 }
		/>
		<rect
			width={ 9.75 }
			height={ 1.5 }
			x={ 57 }
			y={ 50.75 }
			fill="#F6F7F7"
			rx={ 0.75 }
		/>
		<g clipPath="url(#a)">
			<path
				fill="#8796A1"
				d="M79.686 51.631a.506.506 0 0 0 .864.36l1.615-1.617a.505.505 0 0 0 .149-.36v-.016a.504.504 0 0 0-.148-.375l-1.616-1.612a.506.506 0 0 0-.715.715L81.108 50l-1.273 1.273a.505.505 0 0 0-.148.358Z"
			/>
		</g>
		<g clipPath="url(#b)">
			<path
				fill="#8796A1"
				d="M10.313 51.631a.506.506 0 0 1-.863.36l-1.616-1.617a.505.505 0 0 1-.148-.36v-.016a.504.504 0 0 1 .148-.375l1.616-1.612a.506.506 0 0 1 .716.715L8.892 50l1.274 1.273a.505.505 0 0 1 .147.358Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M78.75 47.75h4.5v4.5h-4.5z" />
			</clipPath>
			<clipPath id="b">
				<path fill="#fff" d="M11.25 47.75h-4.5v4.5h4.5z" />
			</clipPath>
		</defs>
	</svg>
);

export const CarouselSimple = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 90 }
		height={ 100 }
		fill="none"
	>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			fill="#fff"
			rx={ 2.438 }
		/>
		<rect
			width={ 88.875 }
			height={ 97.875 }
			x={ 0.563 }
			y={ 1.063 }
			stroke="#8796A1"
			strokeWidth={ 1.125 }
			rx={ 2.438 }
		/>
		<rect
			width={ 77.25 }
			height={ 24.75 }
			x={ 6.375 }
			y={ 37.625 }
			fill="#fff"
			rx={ 1.125 }
		/>
		<rect
			width={ 77.25 }
			height={ 24.75 }
			x={ 6.375 }
			y={ 37.625 }
			stroke="#8796A1"
			strokeWidth={ 0.75 }
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 12 }
			y={ 46.25 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 18 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 47 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 9.75 }
			height={ 2.25 }
			x={ 22.5 }
			y={ 50.75 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<rect
			width={ 7.5 }
			height={ 7.5 }
			x={ 51.75 }
			y={ 46.25 }
			fill="#8796A1"
			rx={ 3.75 }
		/>
		<rect
			width={ 15.75 }
			height={ 2.25 }
			x={ 62.25 }
			y={ 47 }
			fill="#8796A1"
			rx={ 1.125 }
		/>
		<rect
			width={ 12 }
			height={ 2.25 }
			x={ 62.25 }
			y={ 50.75 }
			fill="#546069"
			rx={ 1.125 }
		/>
		<g clipPath="url(#a)">
			<path
				fill="#8796A1"
				d="M79.686 51.631a.506.506 0 0 0 .864.36l1.615-1.617a.505.505 0 0 0 .149-.36v-.016a.504.504 0 0 0-.148-.375l-1.616-1.612a.506.506 0 0 0-.715.715L81.108 50l-1.273 1.273a.505.505 0 0 0-.148.358Z"
			/>
		</g>
		<g clipPath="url(#b)">
			<path
				fill="#8796A1"
				d="M10.313 51.631a.506.506 0 0 1-.863.36l-1.616-1.617a.505.505 0 0 1-.148-.36v-.016a.504.504 0 0 1 .148-.375l1.616-1.612a.506.506 0 0 1 .716.715L8.892 50l1.274 1.273a.505.505 0 0 1 .147.358Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M78.75 47.75h4.5v4.5h-4.5z" />
			</clipPath>
			<clipPath id="b">
				<path fill="#fff" d="M11.25 47.75h-4.5v4.5h4.5z" />
			</clipPath>
		</defs>
	</svg>
);
